
import { FaStar } from "react-icons/fa";
import Clientss from '../assets/images/clent.jpg'
import { useTranslation } from "react-i18next";
import { apiRequest } from '../ApiService/Allapi';
import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";



function Rewes({ data }) {
   const { t } = useTranslation();
   const [review, setReview] = useState([]);

   useEffect(() => {
      setReview(data);
   }, [data]);

   return (
      <>
         <div className="Divider_divider__yaBCO"></div>
         <section className='bg-primary-1 section-padding'>
            <div className='hiring-titk'>
               <h1>{t("ClientSay")}</h1>
            </div>

            <div className='container'>
               <div className='box_rewes'>
                  {Array.isArray(review) ? (
                     review.map((item, index) => (
                        <div className="single-testimonial-item" key={index}>
                           <div className="description">
                              <p>{item?.message}</p>
                           </div>
                           <div className="author-meta">
                              <img src={item?.image} alt={item?.name} title={item?.name} />
                              <div className="content">
                                 <p className="name">{item?.name}</p>
                                 <p className="city-name">{item?.city}</p>
                                 <ul className="client-star">
                                    {Array.from({ length: item?.rating || 0 }).map((_, idx) => (
                                       <li key={idx}><FaStar /></li>
                                    ))}
                                 </ul>
                              </div>
                           </div>
                        </div>
                     ))
                  ) : (
                     <p>No reviews found.</p>
                  )}
               </div>
            </div>
         </section>
      </>
   );
}

export default Rewes 
